import { useCore } from '@/composables/core/index.js'

export default function (to, from, next) {
  const { store } = useCore()
  store.commit('app/setRoutes', {
    previousRoute: from,
    currentRoute: to,
  })
  next()
}
